import React from "react";
import { Box, List, ListItem, Text } from "@chakra-ui/react";

const SnapTradeBenefits: React.FC = () => {
  return (
    <Box w="full" background="var(--dark-gray)" border="1px solid var(--gray)" borderRadius="8px" p="14px">
      <Text fontWeight={600} mb="6px">Why use auto-sync?</Text>
      <List spacing={1} styleType="disc" pl="18px">
        <ListItem>Connect multiple accounts across supported brokers</ListItem>
        <ListItem>Read-only access; you stay in control of your data</ListItem>
        <ListItem>Automatic syncing of balances, positions, and trades</ListItem>
        <ListItem>Disconnect anytime from your account settings</ListItem>
      </List>
    </Box>
  );
};

export default SnapTradeBenefits;


